import {PageLink} from '../../_metronic/layout/core'
import Navigation from '../../components/Navigation/Navigation'
import Profitability from './layouts/Profitability'
import ProductWiseReport from './layouts/ProductWiseReport'
import ClassificationReport from './layouts/ClassificationReport'
import SupplierReport from './layouts/SupplierReport'
import CustomerRepReport from './layouts/CustomerRepReport'
import CustomerReport from './layouts/CustomerReport'
import PurchaserReport from './layouts/PurchaserReport'
import OrderReport from './layouts/OrderReport'
import BrandReport from './layouts/BrandReport'
import PurchaserByBrandReport from './layouts/PurchaserByBrandReport'
import {useSearchParams} from 'react-router-dom'
import useGetOrdersReport from './hooks/useGetOrdersReport'
import {toTitleCase} from '../../utils/string'
import {getReportTable} from './utils'

const ProfitabilityPageCrumbs: Array<PageLink> = [
  {
    title: 'Analytics',
    path: '/analytics/profitability/profitability-report',
    isSeparator: false,
    isActive: true,
  },
  {
    title: 'Profitability',
    path: '/analytics/profitability/profitability-report',
    isSeparator: false,
    isActive: true,
  },
]

const ProfitabilityCustomersPageCrumbs: Array<PageLink> = [
  {
    title: 'Analytics',
    path: '/analytics/profitability/profitability-report',
    isSeparator: false,
    isActive: true,
  },
  {
    title: 'Profitability',
    path: '/analytics/profitability/profitability-report',
    isSeparator: false,
    isActive: true,
  },
  {
    title: 'Dashboard',
    path: '/analytics/profitability/profitability-report',
    isSeparator: false,
    isActive: true,
  },
]

const ProfitabilityPage = () => {
  const [searchParams] = useSearchParams()
  const searchParamsEntries = searchParams?.entries() || null
  const {view, report_type, ...restTableParams} = Object?.fromEntries(searchParamsEntries)
  const reportTable = getReportTable(restTableParams)

  const useGetOrdersReportExports = useGetOrdersReport()
  const {orderCount} = useGetOrdersReportExports

  const pageTitle = `Profitability Report ${report_type ? `- ${toTitleCase(report_type)}` : ''}${
    reportTable ? ` - ${reportTable}` : ''
  }${reportTable && orderCount ? `: ${orderCount}` : ''}`

  return (
    <Navigation
      baseUrl='/analytics/profitability/profitability-report'
      breadcrumbs={ProfitabilityPageCrumbs}
      pageTitle={pageTitle}
      hideNavigation={view === 'dashboard-customers'}
      navigationData={[
        {
          key: 'dashboard',
          label: 'Dashboard',
          component: <Profitability />,
        },
        {
          key: 'dashboard-customers',
          title: 'All Customer Profit report',
          breadcrumbs: ProfitabilityCustomersPageCrumbs,
          component: <Profitability />,
          hide: true,
        },
        {
          key: 'customer-report',
          label: 'Customer',
          component: <CustomerReport />,
        },
        {
          key: 'sales-rep',
          label: 'Sales Rep',
          component: <CustomerRepReport />,
        },
        {
          label: 'Product',
          key: 'product-wise-report',
          component: <ProductWiseReport />,
        },
        {
          label: 'Supplier',
          key: 'supplier-report',
          component: <SupplierReport />,
        },
        {
          label: 'Classification',
          key: 'classification-report',
          component: <ClassificationReport />,
        },
        {
          label: 'Purchaser by Supplier',
          key: 'purchase-by-supplier',
          component: <PurchaserReport />,
        },
        {
          label: 'Purchaser by Brand',
          key: 'purchase-by-brand',
          component: <PurchaserByBrandReport />,
        },
        {
          label: 'Order',
          key: 'order-report',
          component: <OrderReport useGetOrdersReportExports={useGetOrdersReportExports} />,
        },
        {
          label: 'Brand',
          key: 'brand-report',
          component: <BrandReport />,
        },
      ]}
    />
  )
}

export default ProfitabilityPage
